__turbopack_context__.v({
  "callButton": "mental-health-module__-6wktG__callButton",
  "container": "mental-health-module__-6wktG__container",
  "emergency": "mental-health-module__-6wktG__emergency",
  "footer": "mental-health-module__-6wktG__footer",
  "header": "mental-health-module__-6wktG__header",
  "locationIcon": "mental-health-module__-6wktG__locationIcon",
  "phoneIcon": "mental-health-module__-6wktG__phoneIcon",
  "scrollContainer": "mental-health-module__-6wktG__scrollContainer",
  "serviceActions": "mental-health-module__-6wktG__serviceActions",
  "serviceCard": "mental-health-module__-6wktG__serviceCard",
  "serviceHeader": "mental-health-module__-6wktG__serviceHeader",
  "serviceLocation": "mental-health-module__-6wktG__serviceLocation",
  "serviceName": "mental-health-module__-6wktG__serviceName",
  "servicePhone": "mental-health-module__-6wktG__servicePhone",
  "serviceType": "mental-health-module__-6wktG__serviceType",
  "serviceZone": "mental-health-module__-6wktG__serviceZone",
  "servicesGrid": "mental-health-module__-6wktG__servicesGrid",
  "title": "mental-health-module__-6wktG__title",
  "titleCount": "mental-health-module__-6wktG__titleCount",
  "zoneGroup": "mental-health-module__-6wktG__zoneGroup",
  "zoneTitle": "mental-health-module__-6wktG__zoneTitle",
});
